module.exports = __webpack_public_path__ + "static/media/Neutral.62aa39ac.png";